import React, { useRef, useState } from 'react';
import { Link } from 'gatsby';
import Image from "../../components/image";
import ArrowSvg from '-!svg-react-loader!../../assets/images/menu-arrow.svg';

const HomeServices = ({ content }) => {
  const Tabs = useRef(null);
  const [activeTab, setActiveTab] = useState(content?.services[0]);

  if (typeof content === 'undefined' || !content || !activeTab) {
    return null;
  }

  const handleKey = (key, active) => {
    if (key === 'Enter') {
      setActiveTab(active);
      setTimeout(() => {
        document.querySelector('.Home__services__contents p.active').focus();
      }, 300);
    }

  }

  return (
    <section className="Home__services">
      <div className="Container">
        <div className="Home__services__wrap">
          <div className="col-6 Home__services__image">
            <Image source={activeTab.image} />
          </div>
          <div className="col-6 Home__services__content">
            <h2>{content.title}</h2>

            <div className="Home__services__tabs" ref={Tabs}>
              {content.services.map((item, i) => (
                <button
                  key={i}
                  className={activeTab === item ? 'active' : ''}
                  onClick={() => setActiveTab(item)}
                  onKeyDown={(e) => handleKey(e.key, item)}
                  tabIndex={0}
                >{item.name}</button>
              ))}
            </div>

            <div className="Home__services__contents">
              <p>
                {activeTab.text}
                {activeTab.link && <Link to={activeTab.link.url}>
                  {activeTab.link.title} <ArrowSvg />
                </Link>}

              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeServices